import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import {
  ChangeArticlesOfAssociation,
  ChangeArticlesOfAssociationForm,
} from "./changeArticlesOfAssociationDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<ChangeArticlesOfAssociation>,
  data?: ChangeArticlesOfAssociation,
): ChangeArticlesOfAssociationForm {
  return new ChangeArticlesOfAssociationForm(context, data);
}

export function applyForm(form: ChangeArticlesOfAssociationForm): ChangeArticlesOfAssociation {
  return {
    type: DecisionType.changeArticlesOfAssociation,
    articleChanges: form.articleChangeModel.articleChanges.map((d) => d),
  };
}

export function validate(form: ChangeArticlesOfAssociationForm) {
  return form.validate();
}

export function isValid(form: ChangeArticlesOfAssociationForm) {
  return form.isValid;
}

export const changeArticlesOfAssociationHandler: DecisionTypeHandler<
  DecisionType.changeArticlesOfAssociation,
  ChangeArticlesOfAssociation,
  ChangeArticlesOfAssociationForm
> = {
  type: DecisionType.changeArticlesOfAssociation,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent(form, event) {
    form.handleEvent(event);
  },
};
